<!-- <app-modal-popup></app-modal-popup> -->
<header class=" hader-style-1 hader-white-bg" [ngClass]="{'scrolled': isScrolled}" id="commonHeader">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-12" style="padding-top: 7px; padding-bottom: 7px;">
        <div class="header-box">
          <button type="button" (click)="openNav()" class="navbar-toggle collapsed menu-collapsed-button"
            data-toggle="collapse" data-target="#navbar-primary-collapse" aria-expanded="false">
            <i class="fa-solid fa-bars"></i>
          </button>
          <div class="site-branding">
            <a [routerLink]="getLangRoute('/home')" (click)="HeaderStyle1()" title="ACA">
              <img src="assets/images/download.svg" class="logo-black" alt="Logo">
              <!-- <img src="assets/images/Logos-01-01.webp" class="logo-white" alt="Logo"> -->
            </a>
          </div>
          <div class="header-menu hidden-xs collapse navbar-collapse navbar-right ts-mnus header-right-menu"
            id="navbar-primary-collapse">
            <nav class="main-navigation">
              <ul class="menu">
                <li
                  [ngClass]="{ 'ar-menu': currentLang === 'ara' }"
                  class="menu-item has-submenu"
                  (mouseenter)="showVehicleSubmenu = true"
                  (mouseleave)="showVehicleSubmenu = false"
                >
                  <a (click)="HeaderStyle2()" style="cursor: pointer;">
                    {{ 'navbar.vehicles' | translate }}
                    <i class="fa-solid fa-caret-down ml-2"></i>
                  </a>
                  <ul class="submenu open" [@submenuToggle]="showVehicleSubmenu ? 'open' : 'closed'">
                    <li
                      [ngClass]="{ 'ar-menu': currentLang === 'ara' }"
                      routerLinkActive="active"
                      (click)="HeaderStyle2()"
                    >
                      <a routerLink="/vehicle">Auction Vehicles</a>
                    </li>
                    <li
                      [ngClass]="{ 'ar-menu': currentLang === 'ara' }"
                      routerLinkActive="active"
                      (click)="HeaderStyle2()"
                    >
                      <a routerLink="/buy-now-list">Buy Now Vehicles</a>
                    </li>
                  </ul>
                </li>
                <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" class="menu-item has-submenu"
                  (mouseenter)="showSubmenu = true" (mouseleave)="showSubmenu = false">
                  <a (click)="HeaderStyle2()" style="cursor: pointer;">{{ 'navbar.auctions' | translate }}<i
                      class="fa-solid fa-caret-down ml-2"></i></a>
                  <ul class="submenu open" [@submenuToggle]="showSubmenu ? 'open' : 'closed'">
                    <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active"
                      (click)="HeaderStyle2()"
                      *ngIf="showAuctionJoinMessage && isAuctionJoinShow == true && todayAuctionsList.length > 0 && !hasMultipleLanes">
                      <a (click)="auctionJoin(todayAuctionsList[0])"
                        style="cursor: pointer;margin-top: 0px !important; ">{{ 'navbar.join-auction' | translate }}
                        <!-- <span class="blink-red" *ngIf="todayAuctionsList[0]?.auctionStart == true">
                        .
                        </span> -->
                        <span class="blink-red" *ngIf="todayAuctionsList[0]?.auctionStart == true">
                          <img src="../../../assets/aca_images/live-aq.gif" alt=""
                            style="width: 22px; text-align: center;">
                        </span>
                      </a>
                    </li>

                    <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }"
                      class="menu-item has-submenu lane-submenu-parent"
                      *ngIf="showAuctionJoinMessage && isAuctionJoinShow == true && todayAuctionsList.length > 0 && hasMultipleLanes">
                      <a (click)="HeaderStyle2(); toggleLaneSubmenu($event)" style="cursor: pointer;">
                        {{ 'navbar.join-auction' | translate }}
                        <i class="fa-solid fa-caret-right ml-2"></i>
                      </a>
                      <ul class="submenu lane-submenu" [ngClass]="{ open: showLaneSubmenu }"
                        [@submenuToggle]="showLaneSubmenu ? 'open' : 'closed'">
                        <li *ngFor="let lane of todayAuctionLanes" [ngClass]="{ 'ar-menu': currentLang === 'ara' }"
                          routerLinkActive="active" (click)="HeaderStyle2()">
                          <a (click)="auctionJoin(todayAuctionsList[0], lane?.lane)"
                            style="cursor: pointer;margin-top: 0px !important; ">Join {{ lane?.lane | titlecase}}</a>
                        </li>
                      </ul>
                    </li>

                    <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active"
                      (click)="HeaderStyle2()">
                      <a [routerLink]="getLangRoute('/vehicle')">{{ 'navbar.today-auction' | translate }}</a>
                    </li>
                    <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active"
                      (click)="HeaderStyle2()">
                      <a [routerLink]="getLangRoute('/auction-calender')">{{ 'navbar.auction-calendar' | translate
                        }}</a>
                    </li>
                  </ul>
                </li>

                <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active" (click)="HeaderStyle2()">
                  <a [routerLink]="getLangRoute('/buy')">{{ 'navbar.buyers' | translate }}</a>
                </li>
                <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active" (click)="HeaderStyle2()">
                  <a [routerLink]="getLangRoute('/sell')">{{ 'navbar.sellers' | translate }}</a>
                </li>
                <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active" (click)="HeaderStyle2()">
                  <a [routerLink]="getLangRoute('/about-us')">{{ 'about-us-home.about-us' | translate }}</a>
                </li>
                <li [ngClass]="{ 'ar-menu': currentLang === 'ara' }" routerLinkActive="active" (click)="HeaderStyle2()">
                  <a [routerLink]="getLangRoute('/contact-us')">{{ 'navbar.contact-us' | translate }}</a>
                </li>
              </ul>
            </nav>
            <div class="black-shadow"></div>
          </div>
          <!-- Mobile Menu -->

          <div class="mnus-s hidden-sm hidden-md hidden-lg">
            <div id="mySidenav" class="sidenav">
              <a href="javascript:void(0)" class="closebtn mb-3">
                <!-- <i class="fa-solid fa-rectangle-list" style="color: white;" ></i> -->
                <i class="fa-solid fa-arrow-left" (click)="closeNav()"></i>
              </a>
              <ul (click)="closeNav()">
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/vehicle')"><i
                    class="fa-solid fa-car-rear mr-3" style="color: white;"></i><a>{{ 'navbar.vehicles' | translate
                    }}</a></li>
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/auctions')"><i
                    class="fa-solid fa-gavel mr-3" style="color: white;"></i><a>{{ 'navbar.auction-list' | translate
                    }}</a></li>
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/auction-calender')">
                  <i class="fa-solid fa-gavel mr-3" style="color: white;"></i><a>{{ 'navbar.auction-calendar' |
                    translate
                    }}</a></li>
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/buy')"><i
                    class="fa-solid fa-truck-ramp-box mr-3" style="color: white;"></i><a>{{ 'navbar.buyers' |
                    translate }}</a></li>
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/sell')"><i
                    class="fa-solid fa-people-carry-box mr-3" style="color: white;"></i><a>{{ 'navbar.sellers' |
                    translate }}</a></li>
                <!-- <li routerLinkActive="active" (click)="HeaderStyle2()" routerLink="/about-us"><i
                    class="fa-solid fa-chalkboard-user mr-3" style="color: white;"></i><a>About</a></li> -->
                <li routerLinkActive="active" (click)="HeaderStyle2()" [routerLink]="getLangRoute('/contact-us')"><i
                    class="fa-solid fa-address-book mr-3" style="color: white;"></i><a>{{ 'navbar.contact-us' |
                    translate }}</a></li>
                <li (click)="changeLanguage()">
                  <i class="fa-solid fa-globe mr-3" style="color: white;"></i>
                  <a>
                    <span *ngIf="currentLang === 'eng'">{{ 'navbar.arabic' | translate }}</span>
                    <span *ngIf="currentLang === 'ara'">{{ 'navbar.english' | translate }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- End Mobile Menu -->
          <div class="header-menu-right">
            <div class="button-box" *ngIf="!currentUser?.token || !currentUser?.termsAccepted">
              <a id="logInPopupclick" style="padding: 12px; border-radius: 20px;"
                [routerLink]="getLangRoute('/sign-in')" class="secondary-btn secondary-btn__light"><span>{{
                  'navbar.sign-in' | translate }}</span></a>
              <a [routerLink]="getLangRoute('/sign-up')" class="secondary-btn"
                style="padding: 12px; border-radius: 20px;"><span>{{
                  'navbar.sign-up' | translate }}</span></a>

            </div>
            <div class="header-menu-dropdown" *ngIf="currentUser?.token && currentUser?.termsAccepted">
              <div class="btn-group">
                <!-- Toggle Button -->
                <div type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                  style="cursor: pointer;" aria-expanded="false" (click)="onDropdownOpen()">
                  <div class="profile-pic">
                    <img *ngIf="!shortName" height="30" src="../../../assets/img/icons/avatar.png" />
                    <div class="profile-name"
                      style="width: 50px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;"
                      *ngIf="shortName">
                      {{ shortName }}
                    </div>
                  </div>
                  <div *ngIf="currentUser?.name" class="user-name"
                    style="width: 50px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    {{ currentUser?.name }}
                  </div>
                </div>

                <!-- Dropdown Menu -->
                <div #dropdownMenu class="dropdown-menu dropdown-menu-right" style="padding: 0px;">
                  <h4 class="user-name-mobile">{{ 'navbar.hi' | translate }}, {{ currentUser?.name }}</h4>
                  <div class="availableCredit" *ngIf="currentUser.userType === 4 || currentUser.userType === 5">
                    <h4>{{ 'navbar.available-bid-limit' | translate }}</h4>
                    <h1><svg id="Logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" width="1em"
                        height="1em" class="mb-1 mr-1">
                        <path fill="currentColor"
                          d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z" />
                      </svg> <span>{{analyticdata?.creditLimit}}</span> </h1>
                  </div>
                  <button class="dropdown-item" type="button"
                    [routerLink]="getLangRoute(currentUser.userType === 4 || currentUser.userType === 5 ? '/dashboard/buyer/dashboard' : '/dashboard/seller/dashboard')"
                    [queryParams]="{ edit: '1' }">
                    <i class="fa-regular fa-user"></i> {{ 'navbar.user-dashboard' | translate }}
                  </button>
                  <button class="dropdown-item" type="button"
                    [routerLink]="getLangRoute(currentUser.userType === 4 || currentUser.userType === 5 ? '/dashboard/buyer/edit-profile' : '/dashboard/seller/edit-profile')"
                    [queryParams]="{ edit: '1' }">
                    <i class="fa-regular fa-pen-to-square"></i> {{ 'navbar.edit-profile' | translate }}
                  </button>
                  <button class="dropdown-item" type="button"
                    [routerLink]="getLangRoute(currentUser.userType === 4 || currentUser.userType === 5 ? '/dashboard/buyer/edit-profile' : '/dashboard/seller/edit-profile')"
                    [queryParams]="{ pass: '2' }">
                    <i class="fa-solid fa-unlock-keyhole"></i> {{ 'navbar.change-password' | translate }}
                  </button>
                  <button class="dropdown-item" type="button"
                    [routerLink]="getLangRoute(currentUser.userType === 4 || currentUser.userType === 5 ? '/dashboard/buyer/edit-profile' : '/dashboard/seller/edit-profile')"
                    [queryParams]="{ plan: '1' }">
                    <i class="fa-regular fa-file-lines"></i> {{ 'navbar.our-plan' | translate }}
                  </button>
                  <button class="dropdown-item" type="button" (click)="userSessions()">
                    <i class="fa-solid fa-user-clock"></i> {{ 'navbar.login-sessions' | translate }}
                  </button>
                  <button class="dropdown-item" type="button" (click)="logout()">
                    <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ 'navbar.logout' | translate }}
                  </button>
                </div>

              </div>
            </div>
          </div>


          <div class="header-menu-right">
            <div class="button-box">

              <a href="javascript:void(0)" class="secondary-btn secondary-btn__light language-toggle"
                (click)="changeLanguage()" style="padding: 12px; border-radius: 20px;"><span>
                  <i class="fa-solid fa-globe mr-1"></i>
                  <span *ngIf="currentLang === 'eng'">{{ 'navbar.arabic' | translate }}</span>
                  <span *ngIf="currentLang === 'ara'">{{ 'navbar.english' | translate }}</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 auction-join text-capitalize"
    *ngIf="showAuctionJoinMessage && isAuctionJoinShow == true && todayAuctionsList.length > 0"
    [ngStyle]="{ 'background-color': todayAuctionsList[0]?.auctionStart ? '#1fb60b' : '#E81D25' }">
    <div class="col-md-8">
      <marquee style="display: flex;">
        {{ lowercaseTitle (todayAuctionsList[0]?.title) }} -
        {{ todayAuctionsList[0]?.branchName }} - &nbsp;
        {{ todayAuctionsList[0]?.auctionDate | date:'dd-MM-yyyy':'UTC' }}
      </marquee>
    </div>
    <div class="col-md-1">
      <div class="join-link">
        <a href="/auctions" style="padding: 10px;color: white;">{{ 'navbar.join-now' |
          translate }}</a>
      </div>
    </div>
  </div>

</header>